module.exports = __webpack_public_path__ + "static/Tastea3-24a141e767fe9354ab155211d670e092.jpg";